import React, {
  useEffect,
  useState,
  useReducer,
  useMemo,
  useCallback,
} from "react";
import classes from "../../User/Search/search.module.css";
import StoreCard from "../../User/Home/Components/StoreCard";
import SearchIcon from "../../img/search-icon.png";
import backIcon from "../../img/Arrow.png";
import closeIcon from "../../img/Close_round.png";
import { categories } from "../../Config/MainCategory";
import RecentSearch from "./RecentSearch";
import useHttp from "../../Request/use-http";
import { useNavigate } from "react-router";
import ItemCatalogue from "../../User/Home/Components/Homepage/HomePageSelectItems/ItemCatalogue";
import { closeCatDD } from "../../Redux/Reducer/dropdown";
import { useDispatch } from "react-redux";
import AddedToCartBtmSheet from "../../User/Home/Components/Homepage/UI-item,viewAll,BtmSheet/AddedToCartBtmSheet";
import { useTranslation } from "react-i18next";

// ---------------DropDown Reducer FX-------------------------------
const dropDownResultsFX = (searchQueries, action) => {
  searchQueries.splice(0, searchQueries.length);
  if (action.value) {
    searchQueries.push(
      ...categories.filter((category) =>
        category.toLowerCase().trim().includes(action.value)
      )
    );
  }
  if (localStorage.getItem("USER-SEARCH--HISTORY")) {
    searchQueries.push(
      JSON.parse(localStorage.getItem("USER-SEARCH--HISTORY"))[0]
    );
  }
  for (let index = 0; searchQueries.length <= 4; index++) {
    searchQueries.push(
      categories[Math.floor(Math.random() * categories.length)]
    );
  }
  return [...new Set([...searchQueries])];
};
// ----------------------COMPONENT---------------------
export default function Search(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [dropDownEnabler, setdropDownEnabler] = useState(false);
  const [dropDownResults, dispatchDropDown] = useReducer(dropDownResultsFX, []);
  const [Icon, setIcon] = useState(true);
  const [filtered, setFiltered] = useState([]);
  const url = process.env.React_App_Api_url;

  const SearchResults = useCallback((data) => {
    setFiltered(data);
  }, []);

  const {
    isLoading,
    error,
    sendRequest: fetchSearchResults,
  } = useHttp(SearchResults);

  // --------------USE EFFECT-----------------------------
  useEffect(() => {
    if (search.length < 2) {
      return;
    }
    dispatchDropDown({ value: search.toLowerCase().trim() });

    fetchSearchResults({
      url: `${url}/getCategoriesProduct/${search}`,
    });
  }, [search]);
  //--------SEARCH INPUT DEBOUNCE AND SET STAGE FX------
  let debounce = useMemo(() => false, []);

  const SearchInputHandler = useCallback((e) => {
    if (debounce) {
      clearTimeout(debounce);
    }
    debounce = setTimeout(() => {
      setSearch(e.target.value);
    }, 500);
  }, []);

  //-------------------------RECENT HISTORY --------------------------
  const recentHistory = (searchQuery) => {
    if (!localStorage.getItem("USER-SEARCH--HISTORY")) {
      localStorage.setItem(
        "USER-SEARCH--HISTORY",
        JSON.stringify([searchQuery])
      );
      return;
    }
    const rec = JSON.parse(localStorage.getItem("USER-SEARCH--HISTORY"));
    rec.unshift(searchQuery);

    localStorage.setItem(
      "USER-SEARCH--HISTORY",
      rec.length > 5
        ? JSON.stringify([...new Set([...rec.slice(0, 5)])])
        : JSON.stringify([...new Set([...rec])])
    );
  };

  // --------------TOOGLE ICONS---------
  const toggleIcons = () => {
    setIcon((prveState) => !prveState);
  };

  // -----------------------JSX CODE-------------------------
  return (
    <>
      <div className={`w-100 ${classes.searchScreen}`}>
        <div>
          <div
            className={`d-flex align-items-center ${classes.searchScreenSecdiv}`}
          >
            {Icon && (
              <img
                onClick={() => navigate(-1)}
                src={backIcon}
                width="24"
                alt="back"
                className="me-1 d-block"
              />
            )}
            {/* ----------------------------------search input-------- */}
            <div
              className={`w-100 d-flex align-items-center ${classes.searchdiv}`}
            >
              {Icon && (
                <img
                  id="searchIcon"
                  src={SearchIcon}
                  alt=""
                  width={18}
                  className="d-block"
                />
              )}
              {!Icon && (
                <img
                  src={backIcon}
                  alt=""
                  width={24}
                  onClick={() => {
                    setdropDownEnabler(false);
                    toggleIcons();
                  }}
                />
              )}
              <input
                id="myText"
                type="text"
                className="form-control searchinput"
                placeholder={t("Search for Dal")}
                onChange={SearchInputHandler}
                onClick={() => {
                  setdropDownEnabler(true);

                  dispatchDropDown("");
                }}
                onFocus={toggleIcons}
              />
              {!Icon && (
                <img
                  onClick={() => {
                    setdropDownEnabler(false);
                    toggleIcons();
                  }}
                  src={closeIcon}
                  alt="Close"
                  width={24}
                  style={{
                    marginLeft: "8px",
                  }}
                />
              )}
            </div>
            {/* ------------------------------------- */}
          </div>
          {/* --------------DROP DOWN-------------------- */}
          {dropDownEnabler && (
            <div className="search-wrap">
              <div
                onClick={() => {
                  setdropDownEnabler(false);
                  toggleIcons();
                }}
                className={"searchlistback " + classes.backdrop}
              ></div>
              <ul className={"searchlist " + classes.options}>
                {dropDownResults.map((searchQuery, i) => (
                  <li
                    key={i}
                    onClick={() => {
                      dispatch(closeCatDD());
                      navigate(`/${searchQuery}`);
                      document.getElementById("myText").value = searchQuery;
                      setSearch(searchQuery);
                      recentHistory(searchQuery);
                    }}
                    className={classes.option}
                  >
                    <img
                      src={SearchIcon}
                      alt=""
                      width={18}
                      style={{ marginRight: "8px", opacity: "0.4" }}
                    />
                    {`${searchQuery}`}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {/* -------------------RECENT SEARCHES-------------------- */}
          <RecentSearch search={setSearch} />

          {/* ------------------------TRENDING SEARCHES------------------------ */}
          <ItemCatalogue
            title={t("Trending Searches")}
            param="getCategoriesProduct/trending" //change the param
            theme={false}
          />
          {/* ------------------------------------------------------------ */}
        </div>

        {false &&
          (filtered?.length ? (
            <>
              <div style={{ height: "50px" }}></div>
              {filtered?.map((el, i) => (
                <StoreCard brands={el?.brands} info={el?.info} key={i} />
              ))}
              <div className="gap"></div>
            </>
          ) : (
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                height: "100vh",
                width: "100vw",
              }}
            >
              <div className="pad"></div>
              <div className="uil uil-confused fs-xxl text-grey lh-1"></div>
              <span className="fs-3 text-muted text-center">
                {t("Oops, No results!")}
              </span>
              <div className="text-grey">
                {t("Try searching something else")}
              </div>
            </div>
          ))}
        <AddedToCartBtmSheet />
      </div>
    </>
  );
}
